import {
  CC_CONNECTED,
  CC_DISCONNECTED,
  SET_WS_CONNECTION,
} from "../actionTypes";

const defaultState = {
  ccConnected: false,
  wsStatus: "connecting",
};

const orders = (state = defaultState, action) => {
  //eslint-disable-next-line
  const { type, payload } = action;

  switch (type) {
    case CC_CONNECTED:
      return { ...state, ccConnected: true };
    case CC_DISCONNECTED:
      return { ...state, ccConnected: false };
    case SET_WS_CONNECTION:
      return { ...state, wsStatus: payload };
    default:
      return state;
  }
};

export default orders;
